export default {"src":"/_next/static/media/Alzheimers Disease.45a49635.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};